export enum AmpProduct {
    CategoryPageBanner = 'Category Page Banner',
    FeaturedAuctions = 'Featured Auctions',
    SearchPageBanner = 'Search Page Banner',
}
